import React from 'react';

export default function SimpleCard({
                                     icon,
                                     iconColor = 'coolGray-700',
                                     iconSize = 'sm',
                                     text = '',
                                     children,
                                     className,
                                     iconHeight = 'h-4',
                                     showBorder,
                                   }) {

  const _iconColor = `-${iconColor.split('-')[1]}-${iconColor.split('-')[2]}`;

  return (
      <div
          className={`${className} flex flex-row gap-5 items-center bg-white ${showBorder ?
              'border border-gray-200 hover:border' + _iconColor :
              ''}  transition duration-500  px-5 py-3 rounded-2xl max-w-2xl cursor-default`}>

        {icon}
        <p className={'text-sm'}>
          {text}
          {children}
        </p>
      </div>
  );

}